import React from 'react'
import { useTranslation } from 'react-i18next'
import favicon from '../images/favicon.ico'

const getMetaDescription = (isBaseLayout, frontmatter) => {
  const { t } = useTranslation()
  if (isBaseLayout) {
    if (frontmatter?.meta_description ?? undefined) {
      return frontmatter.meta_description
    } else {
      return ''
    }
  } else {
    return t('layout.Meta.Description')
  }
}

export const Head = (props) => {
  const { isBaseLayout, title, frontmatter, isTestSuite } = props.pageContext
  let metaTitle = (title !== undefined ? `${title} - ` : '') + 'Hetzner Docs'
  const metaDescription = getMetaDescription(isBaseLayout, frontmatter)

  if (isTestSuite) {
    metaTitle = 'Markdown test suite - Hetzner Docs'
  }

  return (
    <>
      <title>{metaTitle}</title>
      {!isTestSuite && (
        <meta
          name="description"
          content={metaDescription}
        />
      )}
      <link rel='shortcut icon' type='image/ico' href={`${favicon}`} />
    </>
  )
}
